// «💡 توجيه» على متابعةٍ بعينها (0191، قرار المالك 06/10/2026: «وانا بشوف مواقف الشباب ممكن يحضرنى توجيه ليهم يعملوه مع
// العميل فعاوز ابعتها بحيث يوصله اشعار ف الموقف دا بعينه… فيعمله فيحجز بعدها العميل»). يبعته المالك أو محمد إبراهيم
// («انا او محمد ابراهيم»)، «نصيحة بلا موعد».
//
// ثلاث قطع: نافذة الإرسال (للإدارة)، وشريط التوجيه على كارت العميل عند البياع (يعلّم «شفته» بمجرّد ظهوره، و«✔ نفّذته» بردٍّ
// اختياري)، وشارة الحالة للإدارة: اتبعت / شافه / نفّذه + ردّه.
import { useEffect, useState } from 'react';
import { ApiError, get, post, type FollowUp } from '../lib/api.ts';

interface CoachingItem { id: string; body: string; createdAt: string; seenAt: string | null; doneAt: string | null; reply: string | null; authorName: string }
const stateAr = (c: CoachingItem) => (c.doneAt ? '✔ نفّذه' : c.seenAt ? 'شافه' : 'لسه ما شافهوش');
const dayAr = (iso: string) => new Date(iso).toLocaleString('ar-EG-u-nu-latn', { timeZone: 'Africa/Cairo', day: '2-digit', month: '2-digit', hour: 'numeric', minute: '2-digit' });
import { Alert, Modal, TextArea } from '../components/ui.tsx';

export function CoachModal({ f, onClose, onSent }: { f: FollowUp; onClose: () => void; onSent: () => void }) {
  const [body, setBody] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  /**
   * **التوجيهات السابقة على العميل ده** قبل الكتابة (المالك 06/10/2026: «لو انا كنت عامل توجيه لازم تعرف محمد ان ف توجيه اتعمل
   * ويظهرله علشان ميبعتش لنفس الحاجه مرتين») — من بعثها ومتى وحالتها وردّ البياع. والإرسال يبقى متاحًا: توجيهٌ مختلف جائز.
   */
  const [history, setHistory] = useState<CoachingItem[] | null>(null);
  useEffect(() => {
    get<{ items: CoachingItem[] }>(`/follow-ups/${f.id}/coaching`).then(r => setHistory(r.items)).catch(() => setHistory([]));
  }, [f.id]);
  async function send() {
    setBusy(true); setError(null);
    try { await post(`/follow-ups/${f.id}/coaching`, { body: body.trim() }); onSent(); onClose(); }
    catch (e) { setError(e instanceof ApiError ? e.message : 'تعذّر إرسال التوجيه'); }
    finally { setBusy(false); }
  }
  return (
    <Modal size="sm" title={`💡 توجيه لـ${f.salesName} على عميل ${f.customerName}`} onClose={onClose}>
      <p className="text-xs text-ink-500">يوصله إشعار بالتوجيه على العميل ده بالذات، ويفضل ظاهر له على كارت العميل لحد ما يعلّم «نفّذته».</p>
      {error && <div className="mt-2"><Alert>{error}</Alert></div>}
      {history && history.length > 0 && (
        <div role="note" aria-label="توجيهات سابقة" className="mt-3 rounded-xl border border-amber-200 bg-amber-50 p-2.5 text-sm">
          <p className="font-bold text-amber-900">⚠️ فيه {history.length === 1 ? 'توجيه اتبعت' : `${history.length} توجيهات اتبعتت`} قبل كده على العميل ده:</p>
          <ul className="mt-1.5 max-h-40 space-y-1.5 overflow-y-auto">
            {history.map(c => (
              <li key={c.id} className="rounded-lg bg-white/70 px-2 py-1.5">
                <span className="block text-xs text-ink-600"><b>{c.authorName}</b> · <span dir="ltr">{dayAr(c.createdAt)}</span> · {stateAr(c)}</span>
                <span className="block text-ink-900">{c.body}</span>
                {c.reply && <span className="block text-xs text-emerald-800">ردّه: {c.reply}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
      <label className="mt-3 block">
        <span className="label">التوجيه</span>
        <TextArea rows={4} value={body} maxLength={1000} autoFocus onChange={e => setBody(e.target.value)}
          placeholder="مثلًا: قوله إن برنامج تركيا فيه خصم لو حجز قبل الخميس، واعرض عليه فندق كذا" />
      </label>
      <div className="mt-3 flex gap-2">
        <button type="button" className="btn-primary flex-1 px-4 py-2" disabled={busy || body.trim().length < 2} onClick={() => void send()}>
          {busy ? 'جارٍ الإرسال…' : 'ابعت التوجيه'}
        </button>
        <button type="button" className="btn-ghost px-4 py-2" disabled={busy} onClick={onClose}>إلغاء</button>
      </div>
    </Modal>
  );
}

/** عند البياع: شريط أصفر فوق العميل — يعلّم «شفته» بظهوره، و«✔ نفّذته» بردٍّ اختياري */
export function CoachingBanner({ f, onChanged }: { f: FollowUp; onChanged: () => void }) {
  const [reply, setReply] = useState('');
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (f.coachingId && f.coachingState === 'SENT') void post(`/coaching/${f.coachingId}/seen`, {}).catch(() => { /* علامةٌ لا تُسقط الشاشة */ });
  }, [f.coachingId, f.coachingState]);
  if (!f.coachingId || !f.coachingBody || f.coachingState === 'DONE') return null;
  async function done() {
    setBusy(true); setError(null);
    try { await post(`/coaching/${f.coachingId}/done`, reply.trim() ? { reply: reply.trim() } : {}); onChanged(); }
    catch (e) { setError(e instanceof ApiError ? e.message : 'تعذّر التعليم'); }
    finally { setBusy(false); }
  }
  return (
    <div role="status" aria-label="توجيه الإدارة" className="mt-1 rounded-lg border-s-4 border-amber-400 bg-amber-50 p-2 text-xs text-amber-950">
      <div><b>💡 توجيه الإدارة:</b> {f.coachingBody}</div>
      {error && <div className="mt-1 text-rose-700">{error}</div>}
      {open ? (
        <div className="mt-1.5 flex flex-wrap items-end gap-1.5">
          <TextArea rows={1} value={reply} maxLength={500} aria-label="ردّك على التوجيه" placeholder="كلّمته، هيرد بكرة (اختياري)"
            className="min-w-0 flex-1 py-1 text-xs" onChange={e => setReply(e.target.value)} />
          <button type="button" className="rounded-md bg-emerald-600 px-2.5 py-1 text-xs font-bold text-white disabled:opacity-50" disabled={busy} onClick={() => void done()}>✔ نفّذته</button>
          <button type="button" className="btn-ghost min-h-0 px-2 py-1 text-xs" disabled={busy} onClick={() => setOpen(false)}>إلغاء</button>
        </div>
      ) : (
        <button type="button" className="mt-1.5 rounded-md bg-emerald-600 px-2.5 py-1 text-xs font-bold text-white hover:bg-emerald-700" onClick={() => setOpen(true)}>✔ نفّذته</button>
      )}
    </div>
  );
}

/** عند الإدارة: حالة آخر توجيه على العميل — اتبعت / شافه / نفّذه (وردّه) */
export function CoachingChip({ f }: { f: FollowUp }) {
  if (!f.coachingId || !f.coachingState) return null;
  const s = f.coachingState;
  const tone = s === 'DONE' ? 'bg-emerald-100 text-emerald-800' : s === 'SEEN' ? 'bg-sky-100 text-sky-800' : 'bg-amber-100 text-amber-900';
  const label = s === 'DONE' ? '💡 نفّذ التوجيه' : s === 'SEEN' ? '💡 شاف التوجيه' : '💡 توجيه اتبعت';
  // ومن بعثه — فيعرف المالك ومحمد إبراهيم أن الآخر وجّه هنا (06/10/2026)
  const by = f.coachingAuthor ? ` من ${f.coachingAuthor}` : '';
  return (
    <span className={`inline-flex max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${tone}`}
      title={`${f.coachingBody ?? ''}${f.coachingReply ? ` — ردّه: ${f.coachingReply}` : ''}`}>
      {label}{by}{f.coachingReply && <span className="truncate font-normal">· {f.coachingReply}</span>}
    </span>
  );
}
